import { AfterViewInit, Component, Input } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { Util } from '../../ui/Util';
@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent implements AfterViewInit {

  apiURL: string;
  eudravigilanceUrl: string;
  @Input() maintenanceType: string | undefined;
  constructor() {
    this.apiURL = environment.apiUrl;
    this.eudravigilanceUrl = environment.eudravigilanceUrl;
  }
  
  ngAfterViewInit(): void {
    Util.markAppAsReady();
  }
}
